import ProfileScreenConnector from './ProfileScreenConnector';

export default ProfileScreenConnector;
